module.exports = __webpack_public_path__ + "static/media/news-seed.d3aa9aba.jpg";